"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userRef = exports.User = void 0;
var mobx_1 = require("mobx");
var mobx_keystone_1 = require("mobx-keystone");
var firebase_1 = __importDefault(require("../services/firebase"));
var User = /** @class */ (function (_super) {
    __extends(User, _super);
    function User() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getRefId = function () { return _this.username; };
        _this.startListeningForPositions = (0, mobx_keystone_1._async)(function () {
            var snapshot, val, key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.positionsRef) return [3 /*break*/, 2];
                        this.clearPath();
                        this.positionsRef = firebase_1.default.db.ref("users/".concat(this.username, "/positions"));
                        return [5 /*yield**/, __values((0, mobx_keystone_1._await)(this.positionsRef.once('value')))];
                    case 1:
                        snapshot = _a.sent();
                        val = snapshot.val();
                        for (key in val) {
                            this.addToPath(val[key]);
                        }
                        this.setPathFromSnapshot(snapshot);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
        return _this;
    }
    Object.defineProperty(User.prototype, "currentPosition", {
        get: function () {
            if (this.path.size > 0) {
                return Array.from(this.path).slice()[this.path.size - 1];
            }
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "fullName", {
        get: function () {
            if (this.firstName && this.lastName) {
                return "".concat(this.firstName, " ").concat(this.lastName);
            }
            return this.name;
        },
        enumerable: false,
        configurable: true
    });
    User.prototype.update = function (value) {
        Object.assign(this, value);
    };
    User.prototype.addToPath = function (position) {
        this.path.add(position);
    };
    User.prototype.clearPath = function () {
        this.path.clear();
    };
    User.prototype.setPathFromSnapshot = function (snapshot) {
        var val = snapshot.val();
        if (val) {
            for (var key in val) {
                this.addToPath(val[key]);
            }
        }
    };
    User.prototype.stopListeningForPositions = function () {
        if (this.positionsRef) {
            this.positionsRef.off();
            this.positionsRef = undefined;
        }
    };
    User.prototype.addPositionToFirebase = function (position, firstGps) {
        var geofirePositionRef = firebase_1.default.geofire;
        var positionRef = firebase_1.default.db.ref("users/".concat(this.username, "/positions"));
        var childRef = positionRef.push(__assign(__assign({}, position), { firstGps: firstGps }));
        geofirePositionRef.set(childRef.key, [
            position.latitude,
            position.longitude,
        ]);
        return childRef.key;
    };
    __decorate([
        mobx_1.observable
    ], User.prototype, "positionsRef", void 0);
    __decorate([
        mobx_1.computed
    ], User.prototype, "currentPosition", null);
    __decorate([
        mobx_1.computed
    ], User.prototype, "fullName", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], User.prototype, "update", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], User.prototype, "addToPath", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], User.prototype, "clearPath", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], User.prototype, "setPathFromSnapshot", null);
    __decorate([
        mobx_keystone_1.modelFlow
    ], User.prototype, "startListeningForPositions", void 0);
    __decorate([
        mobx_keystone_1.modelAction
    ], User.prototype, "stopListeningForPositions", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], User.prototype, "addPositionToFirebase", null);
    User = __decorate([
        (0, mobx_keystone_1.model)('doc-mate/User')
    ], User);
    return User;
}((0, mobx_keystone_1.Model)({
    username: (0, mobx_keystone_1.prop)(),
    organization: (0, mobx_keystone_1.prop)(),
    address: (0, mobx_keystone_1.prop)(),
    driversLicense: (0, mobx_keystone_1.prop)(),
    email: (0, mobx_keystone_1.prop)(),
    name: (0, mobx_keystone_1.prop)(),
    firstName: (0, mobx_keystone_1.prop)(),
    lastName: (0, mobx_keystone_1.prop)(),
    phoneNumber: (0, mobx_keystone_1.prop)(),
    photo: (0, mobx_keystone_1.prop)(),
    mcNumber: (0, mobx_keystone_1.prop)(),
    cdlNumber: (0, mobx_keystone_1.prop)(),
    isStaff: (0, mobx_keystone_1.prop)(false),
    isDriver: (0, mobx_keystone_1.prop)(false),
    isDispatcher: (0, mobx_keystone_1.prop)(false),
    isShipper: (0, mobx_keystone_1.prop)(false),
    isReceiver: (0, mobx_keystone_1.prop)(false),
    isBroker: (0, mobx_keystone_1.prop)(false),
    path: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.arraySet)(); }),
})));
exports.User = User;
exports.userRef = (0, mobx_keystone_1.rootRef)('doc-mate/UserRef', {
    getId: function (target) {
        if (target instanceof User) {
            return target.username;
        }
    },
});
